"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var VariableNodes = /** @class */ (function () {
    function VariableNodes(cfg) {
        this.type = 'variable';
        _.assign(this, cfg);
    }
    VariableNodes.prototype.normalize = function () { };
    return VariableNodes;
}());
exports.default = VariableNodes;
//# sourceMappingURL=variable-node.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/node/variable-node.js
// module id = 1032
// module chunks = 37